'use client'

import type { AnchorItem } from '@/components/page-anchors/PageAnchors'
import { useEffect, useState } from 'react'

export default function PageAnchorsDropdown({
  anchors,
  label = 'Sections',
}: {
  anchors: AnchorItem[]
  label?: string
}) {
  const [anchorId, setAnchorId] = useState('')

  useEffect(() => {
    if (!anchorId || !document) {
      return
    }

    const anchor = document.querySelector(`[id="${anchorId}"]`)

    if (anchor) {
      const root = document.documentElement
      const offset = parseInt(getComputedStyle(root).getPropertyValue('--header-height'), 10) || 0
      const top = anchor.getBoundingClientRect().top + window.scrollY - offset
      window.scrollTo({ top, behavior: 'smooth' })
    }
  }, [anchorId])

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setAnchorId(event.target.value)
  }

  return (
    <div className="component component--downloads">
      <div className="container @container @[0px]/single-simple:!max-w-[var(--container-s-max-w)]">
        <div className="flex flex-row gap-s bg-theme p-m text-fg gradient-angle-[125deg] theme--gradient-light gradient--master ms:breakout s:flex-col s:rounded-none xs:flex-col s-up:items-center ms-up:rounded-lg">
          {label && (
            <span className="block shrink-0 text-[length:--p-size] font-bold text-fg">{label}</span>
          )}

          <select onChange={handleChange} className="ms-up:max-w-[400px]" defaultValue={''}>
            <option value="" disabled>
              Sections
            </option>
            {anchors.map((anchor, index) => (
              <option key={index} value={anchor.anchor_id}>
                {anchor.title}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  )
}
